import { clearPinVerification } from '../api/pinSession';

let _is401Handling = false;

export function studentFetch(url, options = {}) {
  const token = localStorage.getItem('student_token');
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: token ? `Bearer ${token}` : '',
    },
  }).then(res => {
    if (res.status === 401 && !url.includes('/auth/')) {
      if (_is401Handling) return null;
      _is401Handling = true;
      localStorage.removeItem('student_token');
      localStorage.removeItem('student_data');
      localStorage.removeItem('jahbath_student_grade');
      localStorage.removeItem('jahbath_student_name');
      localStorage.removeItem('jahbath_student_lang');
      clearPinVerification();
      window.alert('انتهت الجلسة. يرجى إدخال الـ PIN من جديد');
      window.location.href = '/student/auth';
      return null;
    }
    return res;
  });
}

export function guardianFetch(url, options = {}) {
  const token = localStorage.getItem('jahbath_token');
  return fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: token ? `Bearer ${token}` : '',
    },
  }).then(res => {
    if (res.status === 401) {
      localStorage.removeItem('jahbath_token');
      localStorage.removeItem('jahbath_guardian_id');
      window.location.href = '/guardian/auth';
      return null;
    }
    return res;
  });
}
